<template>
    <div>
        <div class="detail-header-container">
            <h4 class="page-title">Card Configuration</h4>
            <div class="round-btn" @click="closeDetailPage()"><i class="fas fa-times" /></div>
        </div>

        <el-form ref="myForm" class="card-conf-form-container" :model="myForm" status-icon>
            <!-- <el-form-item prop="cardType">
                <form-select 
                    :inputValue.sync="myForm.cardType"
                    label="Card Type"
                    placeholder="Select a card type "
                    :options="cardTypeOpts"
                    :loading="cardTypeOptsLoading"
                />
            </el-form-item>

            <el-form-item prop="title">
                <form-input 
                    :inputValue.sync="myForm.title"
                    label="Title"
                    placeholder="Card Title"
                />
            </el-form-item> -->
            <p class="option-title">Data Source</p>
            <form-select 
                :input-value.sync="myForm.dataSource"
                placeholder="Select a data source"
                :options="recordingFormOpts"
                :loading="recordingFormOptsLoading"
                @handleChange="handleChangeDataSource"
            />
            <br>

            <p class="option-title">Chart Data</p>
            <el-collapse v-model="chartDataActiveName">
                <el-collapse-item title="X-Axis" name="XAXIS">
                    <form-select 
                        class="configuration-item"
                        :input-value.sync="myForm.xAxisSource"
                        placeholder="Select a category"
                        :options="customFieldOpts"
                        :loading="customFieldOptsLoading"
                    />
                </el-collapse-item>
                <el-collapse-item title="Y-Axis" name="YAXIS">
                    <el-radio v-model="myForm.yAxisGetDataMethod" class="configuration-item" label="AGGREGATE_DATA">Aggregate Data</el-radio>
                    <el-radio v-model="myForm.yAxisGetDataMethod" class="configuration-item" label="ACTUAL_DATA">Actual Data</el-radio>

                    <form-select 
                        v-if="myForm.yAxisGetDataMethod == 'AGGREGATE_DATA'"
                        class="configuration-item"
                        :input-value.sync="myForm.aggregateMethod"
                        placeholder="Select a aggregate method"
                        :options="aggregateOpts"
                        :loading="aggregateOptsLoading"
                    />
                    
                    <form-select 
                        class="configuration-item"
                        :input-value.sync="myForm.yAxisSource"
                        placeholder="Select a value"
                        :options="customFieldOpts"
                        :loading="customFieldOptsLoading"
                    />
                </el-collapse-item>
            </el-collapse>
            <br>


            <div v-if="currentConfigureCardType == 'BAR_CHART' || currentConfigureCardType == 'LINE_CHART' || currentConfigureCardType == 'PIE_CHART'" class="chart-option-container">
                <p class="option-title">Chart Options</p>

                <el-collapse v-model="activeName" accordion>
                    <el-collapse-item title="Title" name="4">
                        <form-checkbox 
                            class="configuration-item"
                            :input-value.sync="chartConfiguration.title.show"
                            label="Show Title"
                        />
                        <div v-if="chartConfiguration.title.show == true">
                            <form-input 
                                class="configuration-item"
                                :input-value.sync="chartConfiguration.title.text"
                                label="Title"
                                placeholder="Chart Title"
                                size="mini"
                                :is-style="true"
                            >
                                <style-field title="Title" :text-style="chartConfiguration.title.textStyle" />
                            </form-input>

                            <form-input 
                                class="configuration-item"
                                :input-value.sync="chartConfiguration.title.subtext"
                                label="Sub-title"
                                placeholder="Sub-title"
                                size="mini"
                                :is-style="true"
                            >
                                <style-field title="Sub-title" :text-style="chartConfiguration.title.subtextStyle" />
                            </form-input>

                            <div>
                                <p class="show-more-text-button" @click="isTitleAdvance = !isTitleAdvance">-- Advance --</p>
                            </div>

                            <div v-show="isTitleAdvance" class="advance-title-container">
                                <form-select 
                                    class="configuration-item"
                                    :input-value.sync="chartConfiguration.title.textAlign"
                                    label="Text Align"
                                    placeholder="The horizontal align of the components"
                                    size="mini"
                                    :options="horizontalAlignOpts"
                                />
                                
                                <form-select 
                                    class="configuration-item"
                                    :input-value.sync="chartConfiguration.title.textVerticalAlign"
                                    label="Vertical Text Align"
                                    placeholder="The vertical align of the components"
                                    size="mini"
                                    :options="verticalAlignOpts"
                                />

                                <form-input-float 
                                    class="configuration-item"
                                    label="Padding"
                                    :input-value.sync="chartConfiguration.title.padding"
                                    size="mini"
                                />
                                
                                <form-input-float 
                                    class="configuration-item"
                                    label="Title Gap"
                                    :input-value.sync="chartConfiguration.title.itemGap"
                                    size="mini"
                                />

                                <position-input
                                    :left.sync="chartConfiguration.title.left"
                                    :top.sync="chartConfiguration.title.top"
                                    :right.sync="chartConfiguration.title.right"
                                    :bottom.sync="chartConfiguration.title.bottom"
                                />
                            </div>
                        </div>
                    </el-collapse-item>

                    <el-collapse-item title="X-Axis" name="2">
                        <form-checkbox 
                            class="configuration-item"
                            :input-value.sync="chartConfiguration.xAxis.show"
                            label="Show X-Axis"
                        />

                        <axis-input
                            :name.sync="chartConfiguration.xAxis.name"
                            :name-location.sync="chartConfiguration.xAxis.nameLocation"
                            :name-text-style.sync="chartConfiguration.xAxis.nameTextStyle"
                            :name-gap.sync="chartConfiguration.xAxis.nameGap"
                            :name-rotate.sync="chartConfiguration.xAxis.nameRotate"
                            :axis-tick.sync="chartConfiguration.xAxis.axisTick"
                            :axis-label.sync="chartConfiguration.xAxis.axisLabel"
                        />
                    </el-collapse-item>

                    <el-collapse-item title="Y-Axis" name="3" />

                    <el-collapse-item title="Legend" name="1">
                        <form-checkbox 
                            class="configuration-item"
                            :input-value.sync="chartConfiguration.legend.show"
                            label="Show legend"
                        />
                        <position-input
                            :left.sync="chartConfiguration.legend.left"
                            :top.sync="chartConfiguration.legend.top"
                            :right.sync="chartConfiguration.legend.right"
                            :bottom.sync="chartConfiguration.legend.bottom"
                        />

                        <form-input-float 
                            class="configuration-item"
                            label="Padding"
                            :input-value.sync="chartConfiguration.legend.padding"
                            size="mini"
                        />
                        
                        <form-input-float 
                            class="configuration-item"
                            label="Title Gap"
                            :input-value.sync="chartConfiguration.legend.itemGap"
                            size="mini"
                        />

                        <form-select 
                            class="configuration-item"
                            :input-value.sync="chartConfiguration.legend.icon"
                            label="Icon"
                            placeholder="Icon of the legend items"
                            size="mini"
                            :options="iconOpts"
                        />
                    </el-collapse-item>

                    <el-collapse-item title="Grid" name="5">
                        <form-checkbox 
                            class="configuration-item"
                            :input-value.sync="chartConfiguration.grid.show"
                            label="Show grid in rectangular coordinate"
                        />
                        <position-input
                            :left.sync="chartConfiguration.grid.left"
                            :top.sync="chartConfiguration.grid.top"
                            :right.sync="chartConfiguration.grid.right"
                            :bottom.sync="chartConfiguration.grid.bottom"
                        />
                    </el-collapse-item>
                </el-collapse>
            </div>
        </el-form>

        <save-btn class="save-btn" @confirmSave="confirmSave()">
            <el-button class="apply-btn" size="small" @click="apply()">Apply</el-button>
        </save-btn>
    </div>
</template>

<script>
import FormInput from "@/components/Form/FormInput";
import FormSelect from "@/components/Form/FormSelect";
import FormCheckbox from "@/components/Form/FormCheckbox";
import FormInputFloat from "@/components/Form/FormInputFloat";
import SaveButton from "@/components/Button/SaveButton";
import { mapGetters } from "vuex";
import StyleField from "@/components/Form/StyleField";
import PositionInput from "@/components/SidebarDetail/EchartConfiguration/PositionInput";
import AxisInput from "@/components/SidebarDetail/EchartConfiguration/AxisInput";
import { formGetAllForDropdown } from "@/api/form";
import { customFieldGetAll } from "@/api/custom_field";

export default {
    components: {
        "save-btn": SaveButton,
        "form-input": FormInput,
        "form-select": FormSelect,
        "form-checkbox": FormCheckbox,
        "form-input-float": FormInputFloat,
        "style-field": StyleField,
        "position-input": PositionInput,
        "axis-input": AxisInput,
    },
    data() {
        return {
            myForm: {},
            activeName: 1,

            cardTypeOpts: [
                { id: "METRIC", name: "Metric", value: "METRIC" },
                { id: "TABLE", name: "Table", value: "TABLE" },
                { id: "PIE_CHART", name: "Pie Chart", value: "PIE_CHART" },
                { id: "BAR_CHART", name: "Bar Chart", value: "BAR_CHART" }
            ],
            cardTypeOptsLoading: false,
                
            legendPositionOpts: [
                { id: "top", name: "Top", value: "top" },
                { id: "right", name: "Right", value: "right" },
                { id: "bottom", name: "Bottom", value: "bottom" },
                { id: "left", name: "Left", value: "left" }
            ],
                
            horizontalAlignOpts: [
                { id: "auto", name: "Auto" },
                { id: "left", name: "Left" },
                { id: "center", name: "Center" },
                { id: "right", name: "Right" }
            ],
                
            verticalAlignOpts: [
                { id: "auto", name: "Auto" },
                { id: "top", name: "Top" },
                { id: "middle", name: "Middle" },
                { id: "bottom", name: "Bottom" }
            ],
                
            iconOpts: [
                { id: "circle", name: "Circle" },
                { id: "rect", name: "Rectangle" },
                { id: "roundRect", name: "Round Rectangle" },
                { id: "triangle", name: "Triangle" },
                { id: "diamond", name: "Diamond" },
                { id: "pin", name: "Pin" },
                { id: "arrow", name: "Arrow" },
                { id: "none", name: "None" }
            ],

            isTitleAdvance: false,

            recordingFormOpts: [],
            recordingFormOptsLoading: true,
                
            customFieldOpts: [],
            customFieldOptsLoading: true,

            aggregateOpts: [
                { id: "sum", name: "Sum" },
                { id: "count", name: "Count" },
            ],
            aggregateOptsLoading: false,

            chartDataActiveName: ""
        };
    },
    computed: {
        chartType() {
            switch (this.currentConfigureCardType) {
            case "BAR_CHART":
                return "bar";
            default:
                return "bar";
            }
        },
        ...mapGetters([
            "info_sidebar_id",
            "info_details",
            "isInfoSidebarShown",
            "chartConfiguration",
            "currentConfigureCardType"
        ]),
    },
    watch: {
        isInfoSidebarShown() {
            if (this.isInfoSidebarShown == false) {
                this.$refs.myForm.resetFields();
            }
        },
        info_details() {
            this.$set(this.myForm, "cardType", this.info_details.type);
        }
    },
    mounted() {
        this.getRecordingForm();
    },
    methods: {
        apply() {
                
            this.chartConfiguration.series = [{
                data: [120, 200, 150, 80, 70, 110, 130],
                type: this.chartType
            }];
            console.log("apply", this.chartConfiguration);
            this.$nextTick(() => {
                this.$store.dispatch("dashboard_layout/addLayoutCard", {
                    "width": 4,
                    "height": 6,
                    "cardType": this.currentConfigureCardType,
                    "chartConfiguration": this.chartConfiguration
                });
            });
            // console.log('personalize_chart', this.$store.state.personalize_dashboard.chartConfiguration)
            // let conf = this.$store.state.personalize_dashboard.chartConfiguration
            // console.log('conf', conf)
            // conf.my_echart.setOption(conf, {
            //     notMerge: false,
            //     lazyUpdate: false,
            //     silent: false
            // });
        },
        async confirmSave() {
            console.log("myForm", this.myForm);
            this.$store.dispatch("dashboard_layout/addLayoutCard", this.myForm);
                
            this.$_triggerSuccessNotify("Add Dashboard Card");
            this.$store.dispatch("info_sidebar/setInfoSidebarObject", {});
            this.$_closeSidebarWithChecking();
        },
        closeDetailPage() {
            this.$store.dispatch("info_sidebar/setInfoSidebar");
        },
        checkConfigurationOption(optionGroup) {
            let cardType = this.myForm.cardType;

            switch (optionGroup) {
            case "CHART":
                if (cardType == "BAR_CHART" || cardType == "PIE_CHART") return true;
                else return false;
            default:
                return false;
            }
        },
        checkCardConfiguration(property) {
            let cardType = this.myForm.cardType;

            switch (property) {
            case "legend":
                if (cardType == "BAR_CHART" || cardType == "PIE_CHART") return true;
                else return false;
            default:
                return false;
            }
        },
        handleChangeDataSource(event) {
            this.getCustomField(event);
        },
        async getCustomField(value) {
            let res = await customFieldGetAll({ "DisablePaging": true, "FormId": value });
            if (res) {
                this.customFieldOpts = res.items;
                this.customFieldOptsLoading = false;
            }
        },
        async getRecordingForm() {
            let res = await formGetAllForDropdown();
            if (res) {
                this.recordingFormOpts = res;
                this.recordingFormOptsLoading = false;
            }
        }
    }
};
</script>

<style lang="css" scoped>
.save-btn {
    margin-top: var(--space-24);
}
.detail-header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.card-conf-form-container {
    margin-top: var(--space-24);
}
.option-title {
    font-weight: 700;
    margin-bottom: var(--space-8);
}
.apply-btn {
    margin-right: var(--space-8);
}
.configuration-item {
    margin-bottom: var(--space-16);
}
.show-more-text-button {
    text-align: center;
    color: var(--main);
    font-size: 12px;
}
.show-more-text-button:hover {
    color: var(--main-color-1);
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/SidebarDetail/DashboardCardConfigurationSidebar.vue